import { useEffect } from "react";

function useTemporaryUrl(path, customOriginalPath) {
  useEffect(() => {
    if (!path) {
      return;
    }

    const originalPath = window.location.pathname + window.location.search;

    const backPath = originalPath === path ?
        customOriginalPath
    :   originalPath;

    // Push new state
    window.history.pushState(null, "", path);

    // When unmounting, revert back
    return () => {
      window.history.pushState(null, "", backPath);
    };
  }, [path, customOriginalPath]);
}

export default useTemporaryUrl;